import React, {useState, useRef, useCallback, useEffect} from 'react';
import ChessboardWithArrow from '../ChessboardWithArrow';
import NotationComponent from '@/Screens/PlayChess/components/NotationComponent';
import StockfishComponent from '../StockfishEngine/StockfishComponent';
import Box from '@/Atoms/Box';
import CCText from '@/Atoms/CCText';
import CCButton from '@/Atoms/CCButton';
import CCColors from '@/Utils/CCColors';
import styles from './styles';
import {Chess} from 'chess.js';
import close from '@/Assets/Images/icons/close.png';
import {Image, Modal} from 'react-native';
import {Switch} from 'react-native-gesture-handler';
import {updateColorWithOpacity} from '@/Utils/CCColors';
import BlackRook from '@/Assets/ChessPieces/Black-Rook.svg';
import WhiteRook from '@/Assets/ChessPieces/White-Rook.svg';
import SlideModal from '@/Atoms/SlideModal';
const ChessOverlayComponent = ({
  fen = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
  onClose,
  mode = 'analysis',
  puzzle = {},
}) => {
  const [startFen, setStartFen] = useState(fen || '');
  // const [isBlackTurnFirst, setIsBlackTurnFirst] = useState(fen?.split(" ")[1] === "b");
  // FEN structure is: "position turn castling enPassant halfmove fullmove"
  // example: "8/8/8/8/8/8/8/k6K b - - 0 1" → 'b' means Black to move first

  const [moves, setMoves] = useState([]);
  const [position, setPosition] = useState(fen || '');
  const [previousFen, setPreviousFen] = useState(fen || '');
  const [moveClicked, setMoveClicked] = useState(null);
  const [moveSelected, setMoveSelected] = useState(null);
  const [hint, setHint] = useState(null);
  const [hint2, setHint2] = useState(null);
  const [showIncorrectHintModal, setShowIncorrectHintModal] = useState(false);
  const gameRef = useRef(new Chess(position || undefined));
  const [moveIndex, setMoveIndex] = useState(0);
  const [solved, setSolved] = useState(false);

  useEffect(() => {
    setPosition(startFen);
  }, [startFen]);

  const handleFlip = () => {
    setStartFen(prevFen => {
      if (!prevFen) return prevFen; // safeguard
      const parts = prevFen.split(' ');
      if (parts.length > 1) {
        parts[1] = parts[1] === 'w' ? 'b' : 'w';
        return parts.join(' ');
      }
      return prevFen;
    });
    setMoves([]);
  };
  // called when user drops a piece on the board
  const makeMove = useCallback(
    (sourceSquare, targetSquare) => {
      const fen = gameRef.current.fen();
      console.log('asd', fen);
      const move = gameRef.current.move({
        from: sourceSquare,
        to: targetSquare,
        promotion: 'q', // default promote to queen
      });
      console.log('move plaYed', move);

      if (moveClicked) {
        setMoves(prevMoves =>
          prevMoves.slice(0, moveSelected?.selectedMoveNumber),
        );
      }
      setMoveClicked(false);

      if (move) {
        setMoves(prev => [...prev, {move: move.san}]);
        setPreviousFen(position);
        setPosition(gameRef.current.fen()); // update new position
        // return true; // valid move
      } else {
        return false; // illegal move → snapback
      }
      if (mode == 'puzzle' && puzzle?.move_list) {
        console.log('puzzle', puzzle, moveIndex);
        const expectedPlayerMove = puzzle.move_list[moveIndex];
        const playedLan = move.lan;
        console.log('asdd', expectedPlayerMove, playedLan);
        if (expectedPlayerMove?.move === playedLan) {
          // ✅ Player move is correct
          const nextIndex = moveIndex + 1;
          setMoveIndex(nextIndex);

          // ✅ Check if there is an opponent reply
          const opponentMoveObj = puzzle.move_list[nextIndex];

          if (opponentMoveObj) {
            // Delay before playing engine move
            setTimeout(() => {
              const pfen = gameRef.current.fen();
              const autoMove = gameRef.current.move(opponentMoveObj.move);

              if (autoMove) {
                setMoves(prev => [...prev, {move: autoMove.san}]);
                setPreviousFen(pfen);
                setPosition(gameRef.current.fen());
                setMoveIndex(prev => prev + 1);
              }

              // Puzzle complete?
              if (nextIndex + 1 >= puzzle.move_list.length) {
                console.log('✅ Puzzle Completed');
                setSolved(true);
              }
            }, 700); // delay in ms
          } else {
            // ✅ Puzzle complete (no reply move)
            console.log('✅ Puzzle Completed');
            setSolved(true);
          }
        } else {
          // ❌ Wrong move → revert

          console.log('❌ Wrong move, reverting to previous position');
          setTimeout(() => {
            console.log('asd', fen);
            setPosition(fen);
            setMoves(prevMoves => prevMoves.slice(0, -1));
          }, 500);

          return false;
        }
      }
    },
    [position, moveClicked, moveSelected],
  );

  useEffect(() => {
    gameRef.current = new Chess(position);
  }, [position]);

  useEffect(() => {
    console.log('moveSelected', moveSelected);
    if (mode == 'puzzle' && moveClicked && moveSelected) {
      setMoves(prevMoves =>
        prevMoves.slice(0, moveSelected?.selectedMoveNumber),
      );
      setMoveIndex(moveSelected?.selectedMoveNumber - 1);
    }
  }, [moveSelected]);

  // reset board to startfen
  const resetBoard = useCallback(() => {
    gameRef.current = new Chess(fen || undefined);
    setMoves([]);
    setPosition(gameRef.current.fen());
    setPreviousFen(gameRef.current.fen());
    setStartFen(gameRef.current.fen());
    setMoveClicked(false);
    setMoveIndex(0);
  }, [fen]);

  return (
    <SlideModal
      customStyle={{width: '80vw', height: '90vh'}}
      type="center"
      visible={true}
      modalHeaderTitle={mode === 'puzzle' ? 'Solve a Puzzle' : 'Free Analysis'}
      onClose={onClose}
      useNativeModal={true}>
      {/* <Box style={styles.overlayContainer}> */}
      {/* <Box style={styles.overlayCard}> */}
      {/* Left: Chessboard */}
      {/* <Box
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginBottom: 16,
          }}>
          <CCText fontSize={18}>
            {mode === 'puzzle' ? 'Solve a Puzzle' : 'Free Analysis'}
          </CCText>
          <Box style={{flexDirection: 'row', justifyContent: 'space-between'}}>
            <Box style={styles.closeIcon}>
              <Image source={close} onClick={onClose} style={styles.closeButton} />
            </Box>
          </Box>
        </Box> */}
      <Box style={{flexDirection: 'row'}}>
        <Box style={styles.leftSection}>
          <Box style={styles.chessboardContainer}>
            <ChessboardWithArrow
              boardOrientation={
                startFen?.split(' ')[1] === 'b' ? 'black' : 'white'
              } // can be dynamic later
              position={position}
              onPieceDropExtension={makeMove}
              lastMoveFen={previousFen}
              arePremovesAllowed={false}
              animationDuration={10}
            />
          </Box>

          {solved && (
            <Box style={styles.solved}>
              <CCText style={{fontWeight: 'bold', fontSize: '16px'}}>
                ✅ Puzzle Solved!
              </CCText>

              <CCButton
                onPress={onClose}
                style={{
                  padding: '8px 14px',
                  borderRadius: '6px',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '14px',
                  color: 'white',
                }}>
                Continue Class
              </CCButton>
            </Box>
          )}
        </Box>

        {/* Right: Engine + Moves */}
        <Box style={styles.rightSection}>
          {/* Engine lines */}
          <Box
            style={{
              flexDirection: 'row',
              justifyContent: 'space-around',
              borderRadius: 4,
              borderWidth: 0.5,
              borderColor: CCColors.Grey.Border,
              height: 30,
              alignItems: 'center',
              backgroundColor: CCColors.Primary.lightBrown,
              marginRight: 20,
              marginBottom: 16,
            }}>
            <CCText style={{margin: 16}}>Play as White or Black</CCText>
            <Image
              source={WhiteRook}
              style={{
                height: 30,
                width: 30,
                cursor: 'pointer',
                margin: 16,
              }}
            />
            <Switch
              trackColor={{
                false: updateColorWithOpacity(CCColors.Green, 0.3),
                true: updateColorWithOpacity(CCColors.Green, 0.3),
              }}
              thumbColor={CCColors.Green}
              onValueChange={handleFlip}
              value={startFen?.split(' ')[1] === 'b'}
              disabled={mode !== 'analysis'}
            />
            <Image
              source={BlackRook}
              style={{
                height: 30,
                width: 30,
                cursor: 'pointer',
                margin: 16,
              }}
            />
            {/* <CCText>Play as Black</CCText> */}
          </Box>

          {mode == 'analysis' && (
            <Box style={styles.engineSection}>
              <StockfishComponent fen={position} />
            </Box>
          )}

          {/* Notation */}
          <Box style={styles.notationSection}>
            {/* <CCText weight="bold">Moves</CCText> */}
            <NotationComponent
              moves={startFen?.split(' ')[1] === 'b' ? [{}, ...moves] : moves}
              setPosition={setPosition}
              setMoveClicked={setMoveClicked}
              setMoveSelected={setMoveSelected}
              startfen={startFen}
              setPreviousFen={setPreviousFen}
              playing={true}
              setHint={setHint}
              setHint2={setHint2}
              isBlackTurnFirst={startFen?.split(' ')[1] === 'b'}
              position={position}
              setShowIncorrectHintModal={setShowIncorrectHintModal}
              showPlayerComponent={false}
              selectMoves={mode == 'analysis'}
              maxHeight={'calc(0.6*(80vh - 60px))'}
              // myTurn={startFen?.split(" ")[1] === position?.split(" ")[1]}
            />
          </Box>

          {/* Reset / Close */}
          <Box style={styles.footer}>
            <CCButton onPress={resetBoard} style={styles.resetButton}>
              Reset
            </CCButton>
          </Box>
        </Box>
      </Box>
      {/* </Box> */}
      {/* </Box> */}
    </SlideModal>
  );
};

export default ChessOverlayComponent;
